/* src/app/administration/site/motd/motd.component.scss */
/*# sourceMappingURL=motd.component-57AWTP6D.css.map */
